import { FormGroup } from "@mui/material";
import { DateRangeFilter } from "../../../../../components/dataGridFilter/filter-components/DateRangeFilter";
import { TextFilter } from "../../../../../components/dataGridFilter/filter-components/TextFilter";
import { DropdownFilter } from "../../../../../components/dataGridFilter/filter-components/DropdownFilter";

export const FilterGroup1 = () => {
  const baseKey = "pages.orders.filters";

  return (
    <FormGroup
      sx={{
        bgcolor: "customBackground.box",
        borderRadius: 1,
        mb: 2,
        padding: 2,
        display: "flex",
        gap: 2,
      }}
    >
      <DateRangeFilter name="orderDate" labelKey={`${baseKey}.orderDate`} />
      <TextFilter name="carrierName" labelKey={`${baseKey}.carrierName`} />
      <TextFilter name="storeName" labelKey={`${baseKey}.storeName`} />
      <DropdownFilter
        name="status"
        labelKey={`${baseKey}.status`}
        operator="eq"
        options={orderStatuses.map((status) => ({
          value: status,
          label: `pages.orders.statuses.${status}`,
        }))}
      />
      <DropdownFilter
        name="countryCode"
        labelKey={`${baseKey}.countryCode`}
        operator="eq"
        options={countryCodes.map((code) => ({
          value: code,
          label: code,
        }))}
      />
    </FormGroup>
  );
};

const orderStatuses = [
  "PENDING",
  "RECEIVED",
  "SCHEDULED_FOR_SHIPMENT",
  "SHIPPED",
  "CANCELLED",
];

const countryCodes = [
  "AE",
  "AU",
  "BE",
  "CA",
  "DE",
  "ES",
  "FR",
  "IT",
  "JP",
  "MX",
  "NL",
  "PL",
  "SA",
  "SE",
  "SG",
  "UK",
];
